import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import './DoctorApproverLayout.css';
import DAHeader from '../../Header/DAHeader';
import DoctorApproverMenu from '../../doctorapprover/doctorapprovermenu/DoctorApproverMenu';
import { DoctorApproverProfile } from '../../doctorapprover/DoctorApproverProfile';
import { DADoctors } from '../../doctorapprover/DADoctors';
import { DAActivities } from '../../doctorapprover/DAActivities';
import { DAViewDoctor } from '../../doctorapprover/DAViewDoctor';





interface DoctorApproverLayout {

  children?: ReactNode;
  // Define children as a ReactNode
}
const DoctorApproverLayout: React.FC<DoctorApproverLayout> = ({ children }) => {


  return (
    <div className="elitecap-layout-container">
      <DAHeader/>
      <div >
        <DoctorApproverMenu />
         <Routes>
             <Route path="/daprofile" element={<DoctorApproverProfile />} />
             <Route path="/dadoctors" element={<DADoctors />} />
             <Route path="/daactivity" element={<DAActivities />} />
             <Route path="/viewdadoctorslists/:id" element={<DAViewDoctor />} />

          </Routes>
      </div>
      { children }
      {/* <Footer /> */}
    </div>
  );
};

export default DoctorApproverLayout;
